import './RowsSelected.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Delete } from 'src/components/ProductsTable/components';
// import { UploadFile } from 'src/components';
import { Message, Visible } from 'src/core/components';

// import { Delete, Export } from 'src/components/ProductsTable/components';
import messages from './messages';

const RowsSelectedComponent = ({
  selectedProductsIds,
  // category,
  // subcategory,
  onDelete,
}) => {
  if (!selectedProductsIds?.length) {
    // remove this if when uplaod file is re-nabled
    return null;
  }

  return (
    <div className="rows-selected">
      <div className="rows-selected__message">
        <Visible when={!!selectedProductsIds.length}>
          <Message
            message={{
              ...messages.rowsSelected,
              values: { count: selectedProductsIds.length },
            }}
          />
        </Visible>
      </div>

      <div className="rows-selected__actions">
        <Visible when={selectedProductsIds.length}>
          <div className="rows-selected__export-delete">
            <Delete label={messages.deleteSelected} onDelete={onDelete} />
            {/* <Spacer right={15} />
            <Export productsIds={selectedProductsIds} label={messages.exportSelected} />
            <Spacer right={15} />
            <div className="rows-selected__vertical-divider" />
            <Spacer right={13} /> */}
          </div>
        </Visible>

        {/* <UploadFile {...{
          title: messages.uploadFilesTitle,
          description: {
            ...messages.uploadFilesDescription,
            values: { category, subcategory }
          }
        }}
        /> */}
      </div>
    </div>
  );
};

RowsSelectedComponent.propTypes = {
  selectedProductsIds: PropTypes.array.isRequired,
  // category: PropTypes.string.isRequired,
  // subcategory: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RowsSelectedComponent;
